import { Country } from "../common/actions/Auth";

export function feedAvailable(country: Country) {
  return country === "japan";
}

export default (global as any).I18n;



// WEBPACK FOOTER //
// ./frontend/src/lib/i18n.ts